import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`rent-duration/index`),
    store: (userData) => clientAuth.post(`rent-duration/store`, { json: userData }),
    show: (id) => clientAuth.get(`rent-duration/show/${id}`),
    destroy: (id) => clientAuth.delete(`rent-duration/destroy/${id}`),
    update: (id, userData) => clientAuth.post(`rent-duration/update/${id}`, { json: userData }),
}